import { render, staticRenderFns } from "./friend.vue?vue&type=template&id=b2a24c56&scoped=true"
import script from "./friend.vue?vue&type=script&lang=js"
export * from "./friend.vue?vue&type=script&lang=js"
import style0 from "./friend.vue?vue&type=style&index=0&id=b2a24c56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a24c56",
  null
  
)

export default component.exports